mtl.alloy.factory['tabify'] = (function($) {
    'use strict';

    return function(element, options) {

        var $tabset = $(element);

        var $tabsetHeaders = $tabset.find('.tabset-headers');
        if (!$tabsetHeaders[0]) {
            $tabsetHeaders = $('<div class="tabset-headers"></div>').appendTo($tabset);
        }

        var $tabsetBodies = $tabset.find('.tabset-bodies');
        if (!$tabsetBodies[0]) {
            $tabsetBodies = $('<div class="tabset-bodies"></div>').appendTo($tabset);
        }

        $tabset.children('.tab').each(function() {
            var $tab = $(this);
            var $headerClone = $tab.find('.tab-header').addClass('tabified').clone();
            var $bodyClone = $tab.find('.tab-body').addClass('tabified').clone();

            mtl.alloy.process($headerClone);
            mtl.alloy.process($bodyClone);

            $tabsetHeaders.append($headerClone);
            $tabsetBodies.append($bodyClone);
            $tab.addClass('tabified');
        });

        $tabset.addClass('tabified');

        var $headers = $tabsetHeaders.children();
        var $bodies = $tabsetBodies.children();

        /**
         * Show the tab/body and a given index.
         */
        function showTabIndex(index, instant, force) {

            if (!force && index === $headers.filter('.is-active').index()) {
                return;
            }

            $headers.removeClass('is-active')
                .eq(index).addClass('is-active');

            var $body = $bodies.stop(true, false).css({display: 'none'})
                .eq(index);

            if($body.hasClass('reviews'))
            {
                positionReviewContent($body);
            }

            // Instant transition
            if (instant) {
                $body.css({display: ''});
            }

            // Animated transition
            else {
                $body
                    .css({
                        opacity: 0,
                        display: ''
                    })
                    .animate({
                        opacity: 1
                    }, 200)
                ;

                //Display tabs in view
                var $position = $tabset.position();
                $(document).scrollTop($position.top + 100);
            }

        }

        /**
         * Show the accordion/body and a given index.
         */
        function showAccordionIndex() {

            var accordionHeader = $('.tab-header');

            accordionHeader.each(function() {
                $(this).next().hide();
            });

        }

        function positionReviewContent($container)
        {
            $('#product-widget').remove();
            $container.append($('<div id="product-widget" style="width:100%;">&nbsp;</div>'));

            productWidget("product-widget",{
            store: "sinks-tapscom",
            sku: $('.product-article').data('product-id'), // Multiple SKU"s Seperated by Semi-Colons
            primaryClr: "#10D577",
            neutralClr: "#EBEBEB",
            buttonClr: "#EEE",
            textClr: "#333",
            tabClr: "#eee",
            ratingStars: false,
            showAvatars: true,
            perPage: 10
            });

            $('#full-page-widget').remove();
            $container.append($('<div id="full-page-widget" style="width:100%;">&nbsp;</div>'));
            verticalWidget('full-page-widget',{
              store: 'sinks-tapscom',
              primaryClr: '#11CD6B',
              layout:'fullWidth',
              height: 500,
              numReviews: 21
            });
        }


        /**
         * Click header event.
         */
        $tabset.on('click', '.tab-header', function(event) {

            if(app.breakpoint.is('tablet-l desktop')) {
                showTabIndex($headers.index(this));

                event.preventDefault();

                $('.signposts', $tabset).each(function(){
                    $(this).find('.signpost__content .heading').removeAttr('style').equalHeights();
                });
            }

            if(app.breakpoint.is('phone-s phone-l tablet-s')) {
                $(this).next().slideToggle();

                $('html, body').stop().animate({
                    'scrollTop': $(this).offset().top - $('.layout-header').height() - $('.layout-header-main__search').height()
                }, 900, 'swing', function () {
                });

                if($(this).next().hasClass('reviews'))
                {
                    positionReviewContent($(this).next());
                }

                $(this).toggleClass('open');
            }

        });


        // Find and activate the default index
        var defaultIndex = Math.max(0, $headers.filter('.is-active').index());

        app.breakpoint.when('tablet-l desktop', function() {

            var accordionHeader = $tabset.find('.tab-header');

            accordionHeader.each(function() {
                $(this).next().show();
            });

            showTabIndex(defaultIndex, true, true);
            $('.mobile-accessories').hide();

        }, function() {

            showAccordionIndex();
            $tabset.find('.tab-body.accessories').parent().hide();
            $tabset.find('.mobile-accessories').show();

        });


        app.breakpoint.when('phone-s phone-l tablet-s', function() {

            showAccordionIndex();
            $tabset.find('.tab-body.accessories').parent().hide();
            $('.mobile-accessories').show();

        }, function() {

            var accordionHeader = $tabset.find('.tab-header');

            accordionHeader.each(function() {
                $(this).next().show();
            });

            showTabIndex(defaultIndex, true, true);
            $('.mobile-accessories').hide();
            $tabset.find('.tabset-bodies').show();

        });

    };

}(jQuery));
